import React from 'react';
import "./TagToken.scss";

const TagToken = ({children}) => {
	return <div className="tag-token">{children}</div>;
}

export default TagToken;